/**  Check these links for in-depth documentation:
 *  * https://kazupon.github.io/vue-i18n/guide/number.html
 *  * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat
 */
const localeStrings = [
  // 'ch',
  'en',
  'es',
  'fr',
  'it',
  'pt',
  'zh',
];

const currencyFormats = {
  USD: {
    style: 'currency',
    currency: 'USD',
  },
  'USD int': {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  },
  EUR: {
    style: 'currency',
    currency: 'EUR',
  },
  'EUR int': {
    style: 'currency',
    currency: 'EUR',
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  },
  GBP: {
    style: 'currency',
    currency: 'GBP',
  },
  'GBP int': {
    style: 'currency',
    currency: 'GBP',
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  },
  CNY: {
    style: 'currency',
    currency: 'CNY',
  },
  'CNY int': {
    style: 'currency',
    currency: 'CNY',
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  },
  percent: {
    style: 'percent',
  },
  int: {
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  },
};

const numberFormats = Object.fromEntries(localeStrings.map((l) => [l, currencyFormats]));

export default numberFormats;
